import { render, staticRenderFns } from "./Link.vue?vue&type=template&id=3004ea46"
import script from "./Link.vue?vue&type=script&lang=js"
export * from "./Link.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\androidcode\\zf_tms_vue\\tms_vue\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3004ea46')) {
      api.createRecord('3004ea46', component.options)
    } else {
      api.reload('3004ea46', component.options)
    }
    module.hot.accept("./Link.vue?vue&type=template&id=3004ea46", function () {
      api.rerender('3004ea46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/classic/sidebar/Link.vue"
export default component.exports